<script setup lang="ts">
import type { InteractionPreviewProps } from '../../../../model/assessments/preview-interactions.hook'

import { AppText } from '@shared/ui/typography'

import { usePreviewOpenEnded } from '../../../../model/assessments/preview-interactions.hook'

/** The response area a kid lands on: the allowed formats as tabs, the first one open. Static — the
 *  tabs do not switch and nothing is writable. The prompt lives in the activity's content blocks. */
defineOptions({
  name: 'PreviewOpenEnded',
})

const props = defineProps<InteractionPreviewProps>()

const {
  refTabs,
  refHasTabStrip,
  refActiveFormat,
} = usePreviewOpenEnded(() => props.interaction)
</script>

<template>
  <div class="preview-open-ended">
    <div
      v-if="refHasTabStrip"
      class="preview-open-ended__tabs"
    >
      <span
        v-for="tab in refTabs"
        :key="tab.format"
        class="preview-open-ended__tab"
        :class="{ 'preview-open-ended__tab--active': tab.isActive }"
      >
        {{ tab.label }}
      </span>
    </div>

    <textarea
      v-if="refActiveFormat === 'text'"
      class="preview-open-ended__field"
      rows="3"
      disabled
      placeholder="The kid types their response here."
    />
    <div
      v-else
      class="preview-open-ended__area"
    >
      <AppText
        name="body2"
        color="slate-500"
      >
        <template v-if="refActiveFormat === 'whiteboard'">
          Drawing area — the kid writes their answer by hand.
        </template>
        <template v-else>
          Upload area — the kid adds a photo of their answer.
        </template>
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./PreviewOpenEnded.scss" />
